import React from "react";

// Local Imports
import FC2CBanner from "../../images/graphic_design/from-clutter-2-cash-facebook-cover-banner.jpg";

// Font Awesome Imports
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearchPlus } from "@fortawesome/free-solid-svg-icons";

// React PopUpBox
import { PopupboxContainer, PopupboxManager } from "react-popupbox";
import "react-popupbox/dist/react-popupbox.css";

function GD_Project_3() {
  // From Clutter 2 Cash Generic Facebook Banner
  const openPopupBoxFC2CFBBanner = () => {
    const content = (
      <>
        <div className="image-center">
          <img
            className="portfolio-image-popupbox"
            src={FC2CBanner}
            alt="Screenshot of From Clutter 2 Cash Generic Facebook Banner"
          />
        </div>
        <p>A generic cover banner for company Facebook account</p>
        <a
          className="hyper-link"
          onClick={() =>
            window.open("https://www.facebook.com/FromClutter2CashFL", "_blank")
          }
        >
          Facebook Page
        </a>
      </>
    );
    PopupboxManager.open({ content });
    PopupboxManager.update({
      content,
      config: {
        titleBar: {
          text: "From Clutter 2 Cash Generic Facebook Banner",
        },
      },
    });
  };

  const popupboxConfigFC2CFBBanner = {
    titleBar: {
      enable: true,
      text: "From Clutter 2 Cash Generic Facebook Banner",
    },
    fadeIn: true,
    fadeInSpeed: 500,
  };

  return (
    <>
      <div className="portfolio-image-box" onClick={openPopupBoxFC2CFBBanner}>
        <img
          className="portfolio-image constraints"
          src={FC2CBanner}
          alt="Screenshot of From Clutter 2 Cash Generic Facebook Banner"
        />
        <div className="overflow"></div>
        <FontAwesomeIcon className="portfolio-icon" icon={faSearchPlus} />
      </div>
      <PopupboxContainer {...popupboxConfigFC2CFBBanner} />
    </>
  );
}

export default GD_Project_3;
